import { styled } from "styled-components";
import { AccountBalanceTemplate } from "../../template/AccountBalance";
import CreateFipayTag from "../../template/CreateFipayTag";
import { SendMoneyModal } from "../../template/SendMoneyModal";
import TransactionTable from "../../template/TransactionTable";
import { VirtualCardBanner } from "../../template/VirtualCardBanner";
import { colors } from "../../theme/color";
import { UserTextSubText } from "../UserManagement/UserManagementHeader/UserTextHeader";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { Overlay, LoadingSpinner } from "../AddUserPage/AddUser";
import PaymentReceipt from "../../template/Receipt/PaymentReceipt";
import { useEffect } from "react";
import { resetFormValues } from "../../store/formValues";

export default function AccountBankingService() {
  const { firstModalOpen, secondModalOpen, paymentReceiptModalOpen } =
    useSelector((state: RootState) => state.accountsModal);

  const dispatch = useDispatch();

  useEffect(() => {
    // Dispatch the action to reset form values when navigating away from the component
    return () => {
      dispatch(resetFormValues());
    };
  }, [dispatch]);

  return (
    <>
      <AccountHeader>Accounts</AccountHeader>
      <UserTextSubText>
        Add new products and create payment link
      </UserTextSubText>
      <AccountBalanceTemplate />
      <VirtualCardBanner />
      <TransactionTable />
      {firstModalOpen && <SendMoneyModal />}
      {secondModalOpen && <CreateFipayTag />}
      {paymentReceiptModalOpen && <PaymentReceipt />}
    </>
  );
}

export const AccountHeader = styled.h3`
  color: ${colors.NAVYBLUE};
  font-size: 26px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.5px;
`;
